
import { useState } from "react";
import { Search } from "../../../../assets/icons";
import InputWithIcon from "../../../common/input/InputWithIcon";

export default function SearchSection({ initQuery, onSearch }) {
	const [query, setQuery] = useState(initQuery);

	function handleKeyPress(e) {
		if (e.key === "Enter") {
			onSearch(query);
		}
	}

	return (
		<div className="w-full flex flex-col rounded-[10px] p-[10px] bg-white">
			<div className="font-Vazir-300 text-[16px] text-darkBlue text-center">
				جستجو در سوالات
			</div>
			<div className="lg:w-[330px] flex flex-col justify-center items-center align-middle mx-auto">
				<InputWithIcon
					onChange={(e) => setQuery(e.target.value)}
					onKeyPress={handleKeyPress}
					width="330px"
					marginBlock="10px"
					iconColor="#FF6A4B"
					icon={<Search />}
					placeholder="جستجوی سوالات"
				/>
			</div>
		</div>
	)
}
